@let active = activeMode();
@let aiDisabled = !modeService.aiAvailable();

<nav class="edit-mode-rail" [attr.aria-label]="'document.edit.modeRail.label' | translate">
    <button
        type="button"
        class="rail-button"
        [class.active]="active === 'manual'"
        [attr.aria-pressed]="active === 'manual'"
        [attr.aria-label]="'document.edit.modeRail.manual' | translate"
        [raEditTooltip]="{ text: ('document.edit.modeRail.manual' | translate), position: 'right' }"
        (click)="select('manual')">
        <ra-icon icon="edit" varColor="currentColor" [size]="20" />
    </button>

    <!-- aria-disabled em vez de disabled: botão desabilitado não recebe o hover, e o
         tooltip é justamente o que explica por que a IA não está disponível aqui. -->
    <button
        type="button"
        class="rail-button"
        [class.active]="active === 'ai'"
        [class.unavailable]="aiDisabled"
        [attr.aria-pressed]="active === 'ai'"
        [attr.aria-disabled]="aiDisabled ? 'true' : null"
        [attr.aria-label]="aiTooltipKey() | translate"
        [raEditTooltip]="{ text: (aiTooltipKey() | translate), position: 'right' }"
        (click)="select('ai')">
        <ra-icon icon="message" varColor="currentColor" [size]="20" />
    </button>
</nav>
